import { render, staticRenderFns } from "./liveDialog.vue?vue&type=template&id=6b8bae8c&scoped=true&"
import script from "./liveDialog.vue?vue&type=script&lang=js&"
export * from "./liveDialog.vue?vue&type=script&lang=js&"
import style0 from "./liveDialog.vue?vue&type=style&index=0&id=6b8bae8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8bae8c",
  null
  
)

export default component.exports